import { RichTextNodeType } from "@prismicio/types-internal/lib/customtypes"
import type { Mark } from "@tiptap/core"
import type { Mark as ProsemirrorMark, Schema } from "prosemirror-model"

import { ExtensionType } from "../../models"

export class LabelExtension {
  extType: ExtensionType.Mark = ExtensionType.Mark
  richTextNodeTypes = RichTextNodeType.paragraph
  constructor(
    readonly name: string,
    readonly component: Mark,
    readonly converter: {
      fromPrismic(
        schema: Schema
      ): (elmt: LabelElement) => ProsemirrorMark | undefined
      toPrismic(elmt: ProsemirrorMark): LabelElementData
    }
  ) {}
}

export interface LabelElement {
  type: "label"
  start: number
  end: number
  data: LabelElementData
}

export type LabelElementData = string
